import React, { Component } from "react";
import { Modal, FormTextarea, Button } from "ui-kit-ck-consultant";

export default class ModalResponse extends Component {
  constructor(props) {
    super(props);
    this.state = {
      response: "",
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.show && this.props.show !== prevProps.show && this.props.item) {
      this.setState({
        response: this.props.item.response || "",
      });
    }
  }

  handleSubmit = () => {
    this.props.onResponse(this.props.item.id, this.state.response);
  };

  render() {
    return (
      <Modal
        title="Actions réalisées"
        show={this.props.show}
        onClose={this.props.onClose}
      >
        <FormTextarea
          className="my-10"
          title="Actions réalisées pour résoudre l'anomalie"
          name="response"
          value={this.state.response}
          onChange={(e) => this.setState({ response: e.target.value })}
          rows={5}
        />
        <Button
          className="mt-10"
          text="Valider"
          onClick={this.handleSubmit}
        />
      </Modal>
    );
  }
}
